import { FC, useMemo } from 'react'
import { Offer } from 'common/types/responses'

type OfferDetailHeroSectionType = {
  offerDetail: Offer
}

const OfferDetailHeroSection: FC<OfferDetailHeroSectionType> = ({
  offerDetail,
}) => {
  const isBgLight = useMemo(() => {
    const bgColorValue =
      offerDetail.hero_background_color || 'rgb(255, 255, 255)'
    const isLight =
      bgColorValue
        .replace(/rgba?\(|\s+|\)/g, '')
        .split(',')
        .reduce((a, b) => a + (Number(b) > 255 / 2 ? 1 : 0), 0) >= 2
    return isLight
  }, [offerDetail.hero_background_color])

  const backgroundColor = offerDetail.hero_background_gradient
    ? `background-image: ${offerDetail.hero_background_gradient};`
    : `background-color: ${offerDetail.hero_background_color || '#ffffff'};`
  return (
    <div id='offerdetail-hero-container' style={backgroundColor}>
      <div className='container'>
        <div className='row'>
          <div className='col-lg-5 mt-10 mt-lg-18 pb-32 d-flex align-items-center'>
            <img
              src={offerDetail.brand.logo?.url}
              className='offer-detail-brand-logo d-block mb-4'
              alt={offerDetail.title}
            />
            {/*<span className={`sm-text-medium  ${!isBgLight && 'color-white'}`}>*/}
            {/*  {offerDetail.hero_description}*/}
            {/*</span>*/}
          </div>
          <div
            style={{
              height: 514,
            }}
            className='col-lg-7 d-none d-lg-block overflow-hidden'
          >
            {!!offerDetail.hero_image?.url && (
              <img
                src={offerDetail.hero_image?.url}
                className='d-block object-fit-contain'
                alt={offerDetail.title}
                style={{
                  height: 514,
                  maxWidth: '100%',
                  objectFit: 'contain',
                }}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default OfferDetailHeroSection
